export async function requestPlantUmlDiagram(diagramContent: string, diagramRendererUrl: string, signal?: AbortSignal) {
	return await fetch(`${diagramRendererUrl}/convert/plantuml`, {
		method: "POST",
		body: JSON.stringify({ content: diagramContent }),
		headers: { "Content-Type": "application/json" },
		signal,
	});
}
